import { Alert } from "../../../models/alerts/alert";
import { AlertStatus, AlertType } from "@models/alerts/alerts-enums";
import { AlertRecord } from "../../../models/alerts/alert-record";

export class AlertHelper {
  static isPostponeVisible(alert: Alert | AlertRecord | null | undefined): boolean {
    return Boolean(
      alert
      && alert.status === AlertStatus.New // same as BE AlertStatus.Active
      && alert.type != AlertType.ValidationReport
    );
  }

  static isArchiveVisible(alert: Alert | AlertRecord | null | undefined): boolean {
    return Boolean(
      alert
      && alert.status !== AlertStatus.Archived
    );
  }
}
